import { render, staticRenderFns } from "./sizer-console.vue?vue&type=template&id=fae781b4"
import script from "./sizer-console.vue?vue&type=script&lang=js"
export * from "./sizer-console.vue?vue&type=script&lang=js"
import style0 from "./sizer-console.vue?vue&type=style&index=0&id=fae781b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports